<lib-modal-layout [title]="title()" [subtitle]="''">
  @if (data.requestType !== 'Loss Runs') {
    <div >
      @if (pendingRequestStore.submissionReview?.()?.payrollDefaultedByRenewal) {
        <div class="flex items-center justify-center gap-2 mb-4 text-red font-semibold">
          <span>Renewal automation defaulted Owners, Employee Payroll and Work Percentages</span>
          <a class="w-4 cursor-pointer" title="Edit" (click)="editRenewalPayroll()">
            <lib-icon icon="pen"></lib-icon>
          </a>
        </div>
      }
      <lib-action-form [submissionGuid]="data.id!" [requestType]="data.requestType!" [proposedEffectiveDate]="proposedEffectiveDate" [effectiveDate]="data.effectiveDate" (closeModal)="dialogRef.close()"></lib-action-form>
      <lib-submission-review [model]="pendingRequestStore.submissionReview?.()!"></lib-submission-review>
    </div>
  }
  @if (data.requestType === 'Loss Runs' && pendingRequestStore.lossRunReview?.()) {
    <div>
      <lib-loss-runs-form [model]="pendingRequestStore.lossRunReview?.()!" (closeModal)="dialogRef.close()"></lib-loss-runs-form>
      <lib-ui-loss-runs-review [model]="pendingRequestStore.lossRunReview?.()!"></lib-ui-loss-runs-review>
    </div>
  }
</lib-modal-layout>